import { createReactRouterAdapter } from '@leagueplatform/react-router-adapter';
import { leagueTheme } from '@web-config-app/common';
import {
  appReviewIcon,
  assetsLogo,
  decisionIconSVGRaw,
  moveUpAndDownIcon,
  pdfIcon,
  wrenchIcon,
} from '@web-config-app/core-react-ui';
import { ViteAppEnvironment } from '../../types/app';

// TENANT_ID matches sentry path configured in kubernetes repo
export const TENANT_ID = 'content-and-config-tool';

export const APP_ID = `${TENANT_ID}-web`;

const { MODE, VITE_AUTH0_DOMAIN, VITE_AUTH0_CLIENT_ID } = import.meta.env;

export const commonCoreConfig = {
  tenantId: TENANT_ID,
  clientId: APP_ID,
  routing: { adapter: createReactRouterAdapter() },
  ui: {
    theme: leagueTheme,
    themeOptions: {
      useRems: true,
      noLegacyTheming: true,
      customIcons: {
        appReview: `data:image/svg+xml,${encodeURIComponent(appReviewIcon)}`,
        assetsLogo: `data:image/svg+xml,${encodeURIComponent(assetsLogo)}`,
        moveUpAndDownIcon: `data:image/svg+xml,${encodeURIComponent(
          moveUpAndDownIcon,
        )}`,
        decisionNodeIcon: `data:image/svg+xml,${encodeURIComponent(
          decisionIconSVGRaw,
        )}`,
        pdf: `data:image/svg+xml,${encodeURIComponent(pdfIcon)}`,
        interfaceWrench: `data:image/svg+xml,${encodeURIComponent(wrenchIcon)}`,
      },
    },
  },
};

export const commonCoreAuthClientOptionsDomain = VITE_AUTH0_DOMAIN;
export const commonCoreAuthClientOptionsClientId = VITE_AUTH0_CLIENT_ID;
export const commonCoreAuthClientOptionsRedirectUri = window.location.origin;

export const viteAppEnvironment = MODE as unknown as ViteAppEnvironment;
